import { render } from "./InvestorGateRoute.vue?vue&type=template&id=0205844a&scoped=true"
import script from "./InvestorGateRoute.vue?vue&type=script&lang=js"
export * from "./InvestorGateRoute.vue?vue&type=script&lang=js"

import "./InvestorGateRoute.vue?vue&type=style&index=0&id=0205844a&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0205844a"]])

export default __exports__